import React from 'react';
import * as Cesium from 'cesium';
import cesiumPackage from 'cesium/package.json';
import 'cesium/Build/Cesium/Widgets/widgets.css';
import Button from '@material-ui/core/Button';
import MaterialIcon from '../MaterialIcon';
import loadBaseReplay3DApp from './baseReplay3DApp';
import BaseReplay3DLayout from './baseReplay3DLayout';
import emb200Model from './../../assets/replay_3d/models/emb-200/aeronave.glb';
import airTractorAt502bModel from './../../assets/replay_3d/models/air-tractor-at-502b/aeronave.glb';
import './replay3D.css';

const cesiumIonToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmMjFlMzc4ZC1hMjkzLTRhYTQtYTcxZi01Y2EzMTM0NTczYmUiLCJpZCI6MzIwMzMwLCJpYXQiOjE3NTIxNTc3OTV9.3Hevk1CLhRrpuR2DSjyD2pGdzwmmsKMn0PApg0FoxNc';
const cesiumBaseUrl = 'https://cdn.jsdelivr.net/npm/cesium@' + cesiumPackage.version + '/Build/Cesium/';
const replay3DLoadingTimeMs = 20000;
const aircraftModels = [
  {
    id: 'emb200',
    label: 'EMB-200 Ipanema',
    url: emb200Model,
    scale: 0.2,
    modelHeadingOffsetDeg: 0,
    modelPitchOffsetDeg: 90,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 5,
    sprayMistVerticalOffsetMeters: 0.3
  },
  {
    id: 'air-tractor-at-502b',
    label: 'Air Tractor AT-502B',
    url: airTractorAt502bModel,
    scale: 0.05,
    modelHeadingOffsetDeg: 0,
    modelPitchOffsetDeg: -8,
    modelRollOffsetDeg: 0,
    minimumPixelSize: 18,
    modelAltitudeOffsetMeters: 13,
    sprayMistVerticalOffsetMeters: -8.5,
    propellerGroups: [
      {
        id: 'helice_aviao',
        nodes: ['objpropeller_basic_airtractor'],
        axis: 'z',
        rpm: 900,
        spinSign: -1,
        pivot: [-0.5831, 87.3068, 531.6978]
      },
      {
        id: 'bomba_eolica',
        nodes: ['objpropeller_small_airtractor'],
        axis: 'z',
        rpm: 1400,
        spinSign: -1,
        pivot: [-0.1409, -59.7121, 262.3489]
      }
    ]
  }
];
class Replay3D extends React.Component {
  state = { fullscreen: false, loading: true };
  mounted = false;
  loaded = false;
  loadingTimer = null;

  componentDidMount() {
    this.mounted = true;
    this.configureCesiumRuntime();
    window.__travicarReplay3DTexts = this.props.res;
    window.__travicarReplay3DAircraftModels = aircraftModels;
    window.__travicarReplay3DInitialTilesReady = this.hideLoading;
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    this.loadingTimer = setTimeout(this.hideLoading, replay3DLoadingTimeMs);
    this.loadBaseRuntime();
  }

  componentDidUpdate(prevProps) {
    this.configureCesiumRuntime();
    window.__travicarReplay3DTexts = this.props.res;
    window.__travicarReplay3DAircraftModels = aircraftModels;
    if (prevProps.data !== this.props.data || prevProps.polygons !== this.props.polygons || prevProps.p !== this.props.p || prevProps.modelUrl !== this.props.modelUrl) {
      this.loadOfficialData();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    if (window.__travicarReplay3DInitialTilesReady === this.hideLoading) {
      window.__travicarReplay3DInitialTilesReady = null;
    }
    if (window.__travicarReplay3DDestroy) {
      window.__travicarReplay3DDestroy();
    }
  }

  configureCesiumRuntime = () => {
    window.CESIUM_BASE_URL = cesiumBaseUrl;
    window.Cesium = Cesium;
    Cesium.Ion.defaultAccessToken = cesiumIonToken;
  };


  hideLoading = () => {
    if (!this.mounted) return;

    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }

    if (this.state && this.state.loading) {
      this.setState({ loading: false });
    }
  };

  loadBaseRuntime = () => {
    if (!this.mounted || this.loaded) return;

    loadBaseReplay3DApp();

    this.loaded = true;
    setTimeout(() => this.loadOfficialData(), 300);
  };

  loadOfficialData = () => {
    const appRoot = document.getElementById('replay3dBaseApp');
    if (appRoot) appRoot.classList.remove('panel-collapsed');
    if (!this.loaded || !window.__travicarReplay3DLoadOfficialData) return;
    window.__travicarReplay3DLoadOfficialData(this.props.data, this.props.polygons, this.props.p, this.props.modelUrl, this.props.qualityConfig);
  };

  handleFullscreenChange = () => {
    this.setState({ fullscreen: !!document.fullscreenElement });
  };

  toggleFullscreen = () => {
    const element = document.querySelector('.replay3d-base-overlay');

    if (!element) return;

    if (document.fullscreenElement) {
      document.exitFullscreen();
      this.setState({ fullscreen: false });
      return;
    }

    if (element.requestFullscreen) {
      element.requestFullscreen();
      this.setState({ fullscreen: true });
    }
  };

  render() {
    const fullscreen = this.state && this.state.fullscreen;
    const loading = this.state && this.state.loading;
    const fullscreenIcon = fullscreen ? 'fullscreen_exit' : 'fullscreen';
    const res = this.props.res;
    const fullscreenTitle = fullscreen ? res.SAIR_TELA_CHEIA : res.TELA_CHEIA;

    return (
      <div className="replay3d-base-overlay">
        <div className="replay3d-base-app-host">
          <BaseReplay3DLayout res={res} />
        </div>
        {loading && (
          <div className="replay3d-base-loading">
            <div className="replay3d-base-loading-card">
              <div className="replay3d-base-loading-spinner" />
              <div className="replay3d-base-loading-title">{res.CARREGANDO_REPLAY_3D}</div>
              <div className="replay3d-base-loading-text">{res.PREPARANDO_MAPA_AERONAVE_DADOS_VOO}</div>
            </div>
          </div>
        )}
        <div className="replay3d-base-action-buttons">
          <Button className="replay3d-base-action-button replay3d-base-fullscreen-button" onClick={this.toggleFullscreen} title={fullscreenTitle}>
            <MaterialIcon icon={fullscreenIcon} className="iconMap" />
          </Button>
          <Button className="replay3d-base-action-button replay3d-base-close-button" onClick={this.props.onClose} title={res.FECHAR_REPLAY_3D}>
            <MaterialIcon icon="close" className="iconMap" />
          </Button>
        </div>
      </div>
    );
  }
}

export default Replay3D;
